export function mergeMessages(current, incoming) {
  const rows = new Map(current.map(message => [message.id, message]))
  for (const message of incoming) rows.set(message.id, { ...rows.get(message.id), ...message })
  return [...rows.values()].sort((a, b) => new Date(a.created_at) - new Date(b.created_at) || a.id.localeCompare(b.id))
}

// Mantém o trecho inteiro entre a mensagem antiga e as mensagens recentes.
export async function findMessageInHistory(readPage, messageId, current = [], cancelled = () => false) {
  if (current.some(message => message.id === messageId)) return current
  let rows = await readPage({ limit: 200 })
  while (!cancelled()) {
    if (rows.some(message => message.id === messageId)) return rows
    const before = rows[0]?.created_at
    if (!before) return null
    const older = await readPage({ before, limit: 200 })
    if (!older.length || new Date(older[0].created_at) >= new Date(before)) return null
    rows = mergeMessages(older, rows)
  }
  return null
}
